import { DateFormats, noddiFormatDate } from 'noddi-util';

import { ReactNode } from 'react';
import { NoddiChip } from '../../../../atoms/NoddiChip';
import { NoddiDataTableFilterType, dataTableFilterTypes } from '../../../../types';
import { getActiveFilters } from '../NoddiDataTable/utils';

interface Props {
  filters: NoddiDataTableFilterType[];
  hideLabelPrefix?: boolean;
}

function getLabelPrefix(label: ReactNode, hideLabelPrefix?: boolean) {
  return hideLabelPrefix ? '' : `${label}: `;
}

const NoddiActiveFilterChips = ({ filters, hideLabelPrefix }: Props) => {
  const activeFilters = getActiveFilters(filters);

  return (
    <div className='flex flex-wrap gap-2'>
      {activeFilters.map((filter, filterIndex) => {
        switch (filter.type) {
          case dataTableFilterTypes.timePicker: {
            if (!filter.value) {
              return null;
            }
            return (
              <NoddiChip
                key={filterIndex}
                label={`${getLabelPrefix(filter.label, hideLabelPrefix)}${noddiFormatDate(filter.value, DateFormats.DOTTED_DATE)}`}
                onDelete={filter.clearFilter}
              />
            );
          }
          case dataTableFilterTypes.timePickerStatic: {
            return (
              <NoddiChip
                key={filterIndex}
                label={`${getLabelPrefix(filter.label, hideLabelPrefix)}${noddiFormatDate(filter.value, DateFormats.DOTTED_DATE)}`}
              />
            );
          }
          case dataTableFilterTypes.singleSelect: {
            const label = filter.options.find((option) => option.value === filter.value)?.label;
            return (
              <NoddiChip
                key={filterIndex}
                label={`${getLabelPrefix(filter.label, hideLabelPrefix)}${label}`}
                onDelete={filter.clearFilter}
              />
            );
          }
          case dataTableFilterTypes.multiSelect: {
            const options = filter.options.filter((option) => {
              const value = filter.value.find((value) => value === option.value);
              if (value) {
                return value;
              }
              if (value === 0) {
                return true;
              }
              return undefined;
            });

            return options.map((option, optionIndex) => {
              const filteredValues = filter.value.filter((value) => value !== option.value);

              return (
                <NoddiChip
                  key={`multiSelect-${filterIndex}-${option.value}-${optionIndex}`}
                  label={`${getLabelPrefix(filter.label, hideLabelPrefix)}${option.label}`}
                  // @ts-expect-error
                  onDelete={() => filter.clearFilter(filteredValues)}
                />
              );
            });
          }
          default:
            return null;
        }
      })}
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default NoddiActiveFilterChips;
